export default __webpack_public_path__ + "static/media/camera.a1de28b4.svg";